import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import './App.css';

interface BlogPost {
  id: string;
  title: string;
  slug: string;
  excerpt: string | null;
  author: string;
  image_url: string | null;
  published_at: string;
}

function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).toLowerCase();
}

function Blog() {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/blog')
      .then(res => res.json())
      .then(data => setPosts(data.posts || []))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="App info-page">
      <Navbar />
      <div className="info-content">
        <div className="info-container">
          <h1>blog</h1>

          {loading && <p>loading...</p>}

          {!loading && posts.length === 0 && (
            <p>no posts yet.</p>
          )}

          {posts.map(post => (
            <article key={post.id} style={{ marginBottom: '60px', paddingBottom: '60px', borderBottom: '1px solid #d0d0c0' }}>
              <Link to={`/blog/${post.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <h2 style={{ marginBottom: '8px' }}>{post.title}</h2>
              </Link>
              <p style={{ fontSize: '14px', color: '#888', marginBottom: '20px' }}>{formatDate(post.published_at)}</p>
              {post.image_url && (
                <Link to={`/blog/${post.slug}`}>
                  <img
                    src={post.image_url}
                    alt={post.title}
                    style={{
                      width: '100%',
                      marginBottom: '24px',
                      display: 'block',
                      borderRadius: '4px'
                    }}
                  />
                </Link>
              )}
              {post.excerpt && (
                <p style={{ fontStyle: 'italic', marginBottom: '24px', color: '#666' }}>{post.excerpt}</p>
              )}
              <Link to={`/blog/${post.slug}`} style={{ textDecoration: 'none', color: '#666', fontStyle: 'italic' }}>
                read more
              </Link>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Blog;
